import { Component, CUSTOM_ELEMENTS_SCHEMA, input, InputSignal } from '@angular/core';

@Component({
    selector: 'app-page-layout',
    templateUrl: './page-layout.component.html',
    host: {
        class: 'block h-full min-h-0'
    },
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PageLayoutComponent {
    public overflow: InputSignal<boolean> = input(false);
}
